import React, { useContext } from "react";
import { FaBrain, FaBalanceScale, FaUsers, FaSmile } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./well.jpg";

const Mental: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/mental-health');
    } else {
      navigate('/login', { state: { from: '/booking/mental-health' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Total Wellbeing</span>
          <h1 className="hero-title">Mental Health & Resilience</h1>
          <p className="hero-subtitle">
            A healthy workplace isn't just physically safe—it's psychologically safe.
            Understanding stress, burnout, and emotional resilience.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Beyond Physical Safety</h2>
              <p className="article-text">
                Stress is the "silent killer." Chronic workplace stress leads to anxiety, depression,
                and physical ailments like heart disease. It triggers safety incidents by causing distraction
                and fatigue. Mental health is a safety issue.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Identifying Burnout</h2>
              <p className="article-text">
                Burnout isn't just "tired." It's emotional exhaustion, depersonalization (cynicism),
                and a sense of inefficacy. Signs include irritability, insomnia, withdrawal from teams,
                and a drop in performance.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Stress Management Strategies</h2>
              <p className="article-text">
                <ul style={{ paddingLeft: '20px', color: '#ccc', lineHeight: '1.8' }}>
                  <li><strong>Boundaries:</strong> Disconnect after hours.</li>
                  <li><strong>Connection:</strong> Talk to colleagues; don't isolate.</li>
                  <li><strong>Mindfulness:</strong> Box breathing (4-4-4-4) to reset panic.</li>
                  <li><strong>Perspective:</strong> Focus on what you can control.</li>
                </ul>
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Psychological Safety</h2>
              <p className="article-text">
                A safe team is one where members feel safe to take risks and be vulnerable in front of each other.
                This means you can admit a mistake, ask a "dumb" question, or challenge the status quo
                without fear of punishment or humiliation.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Wellbeing Pillars</h4>
              <ul className="key-list">
                <li><FaBrain className="check-icon" /> Emotional Intelligence</li>
                <li><FaBalanceScale className="check-icon" /> Work-Life Balance</li>
                <li><FaUsers className="check-icon" /> Social Connection</li>
                <li><FaSmile className="check-icon" /> Positive Psychology</li>
              </ul>
            </div>

            <div className="sidebar-widget">
              <h4 className="widget-title">Need Help?</h4>
              <p style={{ color: '#aaa', lineHeight: '1.6', fontSize: '0.9rem' }}>
                It's okay not to be okay. Reach out to HR or use the Employee Assistance Program (EAP)
                for confidential support.
              </p>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Build Resilience</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Create a supportive and high-performing culture.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Mental;
